// @flow

import React from "react";

import { Flex } from "@unifize/sarah";

import NameOrEmail from "src/containers/user/NameOrEmail";
import GroupMembersModal from "../../GroupMembersModal";
import { getFilteredUserNotification } from "src/utils/checklist";

import type { UsersAndGroups } from "src/types";

type Props = {
  newValue: Array<UsersAndGroups>;
  oldValue: Array<UsersAndGroups>;
};

const UserDiffValue = ({ newValue, oldValue }: Props) => {
  const filteredUserNotifications: Array<UsersAndGroups> =
    getFilteredUserNotification(newValue, oldValue);

  return (
    <>
      {filteredUserNotifications.length > 0 && (
        <Flex wrap="wrap">
          {filteredUserNotifications.map((value, index: number) => {
            if (value.type === "user") {
              return (
                <React.Fragment key={value.uid}>
                  <NameOrEmail
                    uid={value.uid}
                    key={value.uid}
                    notificationVariant="value"
                  />
                  {index < filteredUserNotifications.length - 1 && <>,&nbsp;</>}
                </React.Fragment>
              );
            }
            return (
              value.id && (
                <React.Fragment key={value.id}>
                  <GroupMembersModal id={value.id} />
                  {index < filteredUserNotifications.length - 1 && <>,&nbsp;</>}
                </React.Fragment>
              )
            );
          })}
        </Flex>
      )}
    </>
  );
};

export default UserDiffValue;
